import { render, staticRenderFns } from "./AppLayoutNav.vue?vue&type=template&id=4b4b2792&scoped=true"
import script from "./AppLayoutNav.vue?vue&type=script&lang=js"
export * from "./AppLayoutNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4b2792",
  null
  
)

export default component.exports